import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import useLocale from "../hooks/useLocale";
import { graphql } from "gatsby";
import styled from "@emotion/styled";
import { MDXProvider } from "@mdx-js/react";
import useTranslation from "../hooks/useTranslations";
import { MDXRenderer } from "gatsby-plugin-mdx";
import Layout from "../components/layout";
import MdxLink from "../components/mdx/mdx-link";
import LocalizedLink from "../components/localizedLink";
import SEO from "../components/seo";
import { colors, OutLine } from "../style/theme";
import { mq } from "../utils/helper";
import { rhythm } from "../utils/typography";
import useTranslations from "../hooks/useTranslations";

function TableOfContents({ post, locale }) {
  const tr = useTranslation();
  const isFindings =
    post.frontmatter.title === "FINDINGS" ||
    post.frontmatter.title === "النتائج";
  const { isAra } = useLocale();
  const toc = post.tableOfContents.items;

  const url = isAra
    ? `https://medical.syrianarchive.org/assets/pdf_reports/report-arabic.pdf`
    : `https://medical.syrianarchive.org/assets/pdf_reports/Syrian Archive - Medical Facilities Findings PUBLIC - FINAL FORMATTED.pdf`;

  return (
    <div
      css={{
        display: "flex",
        [mq[1]]: {
          display: "none",
        },
      }}
    >
      <ul
        css={{
          marginLeft: "auto",
          position: "sticky",
          top: "5rem",
          left: isAra ? "auto" : rhythm(2),
          right: isAra ? rhythm(3) : "auto",
          maxWidth: rhythm(8),
          marginBottom: rhythm(5),
          maxHeight: "calc(-10rem + 100vh);",
          overflowY: "auto",
          listStyle: "none",
          textAlign: isAra ? "right" : "left",
          direction: isAra ? "rtl" : "ltr",
        }}
      >
        {isFindings && <h3>{tr("Findings")}</h3>}
        {toc?.map((item) => {
          return (
            <li
              key={item.url}
              css={{
                borderBottom: "1px solid #CACACA",
                padding: "0.5rem",
              }}
            >
              <a
                href={item.url}
                css={{
                  color: colors.light,
                  transition: "0.25s",
                  ":hover, :active": {
                    color: colors.light,
                  },
                }}
              >
                {item.title}
              </a>
              {item.items &&
                item.items.map((item) => {
                  return (
                    <li
                      key={item.url}
                      css={{
                        borderBottom: "1px solid #CACACA",
                        padding: "0.25rem",
                        ":first-of-type": {
                          paddingTop: "0.5rem",
                        },
                        ":last-of-type": {
                          borderBottom: "none",
                        },
                      }}
                    >
                      <small>
                        <a
                          href={item.url}
                          css={{
                            color: colors.light,
                            ":hover, :active": {
                              color: colors.light,
                            },
                          }}
                        >
                          {item.title}
                        </a>
                      </small>
                    </li>
                  );
                })}
            </li>
          );
        })}
        {isFindings && (
          <li
            css={{
              borderBottom: "1px solid #CACACA",
              padding: "0.5rem",
            }}
          >
            <a
              href={url}
              css={{
                color: colors.secondary,
                transition: "0.25s",
                ":hover, :active": {
                  color: colors.secondary,
                },
              }}
            >
              {tr("Download the report")}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}

export default function BlogPostTemplate({ data, location }) {
  const siteTitle = data.site.siteMetadata.title;
  const post = data.mdx;
  //const [windowWidthSize, windowHeightSize] = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);
  const { isAra, locale } = useLocale();
  const tr = useTranslations();

  // useEffect(() => {
  //   windowWidthSize < 992 ? setIsMobile(true) : setIsMobile(false);
  // }, [windowWidthSize]);

  // useEffect(() => {
  //   // This is releated to the workaound in gatsby-browser.js file
  //   window.scrollTo(0, 0);
  // }, []);

  const designSystem = {
    table: styled.table({
      direction: isAra ? "rtl" : "ltr",
      textAlign: isAra ? "right" : "left",
    }),
    a: styled(MdxLink)({
      color: colors.primary,
      fontWeight: "bold",
      ":hover": {
        color: colors.primary,
        fontWeight: "bold",
      },
    }),
    p: styled.p({
      direction: isAra ? "rtl" : "ltr",
      textAlign: isAra ? "right" : "left",
      color: colors.dark,
      lineHeight: "26px",
    }),
    h1: styled.h1({}),
    th: styled.th({
      direction: isAra ? "rtl" : "ltr",
      textAlign: isAra ? "right" : "left",
    }),
    td: styled.td({
      direction: isAra ? "rtl" : "ltr",
      textAlign: isAra ? "right" : "left",
    }),
    h2: styled.h2({
      color: colors.secondary,
      textTransform: "uppercase",
      fontSize: "2.5rem",
      fontWeight: "bold",
      marginTop: "4rem",
      marginBottom: "2rem",
    }),
    h3: styled.h3({}),
    h4: styled.h4({}),
    h5: styled.h5({}),
    blockquote: styled.blockquote({
      fontWeight: "bold",
      lineHeight: "43px",
      fontSize: "25px",
      borderLeft: isAra || "6px solid black",
      borderRight: isAra && "6px solid black",
      paddingRight: isAra && "1rem",
      margin: rhythm(1),
      "& p": {
        lineHeight: "43px",
      },
    }),
  };

  return (
    <Layout title={siteTitle} hasFooter={true}>
      <SEO metadata={post.frontmatter} />

      {/* <PostHeader post={data.mdx} location={location} /> */}

      <div
        css={{
          position: "relative",
          paddingTop: rhythm(2),
          background:
            "linear-gradient(180deg, rgba(175,58,0,0.61) 0%, rgba(175,58,0,0.61) 0%, rgba(0,0,0,0.77) 45%,rgba(0,0,0,0.77) 100%);",

          backgroundColor: "#000000",
          color: colors.light,
        }}
      >
        <div
          css={{
            position: "fixed",
            top: "30%",
            left: "3%",
          }}
        >
          <TableOfContents post={post} locale={locale} />
        </div>
        <h1
          css={{
            marginTop: "4rem",
            marginBottom: "2rem",
            display: "flex",
            justifyContent: "center",
            fontSize: " 48.83px",
          }}
        >
          {post.frontmatter.title}
        </h1>

        <div
          css={{
            width: rhythm(32.25),
            margin: "0 auto",
            /* marginBottom: rhythm(4), */
            justifySelf: "center",
          }}
        >
          <div
            css={{
              backgroundColor: "#060200",
              padding: "3rem",
              direction: isAra ? "rtl" : "ltr",
              textAlign: isAra ? "right" : "left",
            }}
          >
            <MDXProvider
              components={{
                a: designSystem.a,
                p: designSystem.p,
                h1: designSystem.h1,
                h2: designSystem.h2,
                h3: designSystem.h3,
                h4: designSystem.h4,
                h5: designSystem.h5,
                table: designSystem.table,
                th: designSystem.th,
                td: designSystem.td,
                em: designSystem.em,
                OutLine: OutLine,
                blockquote: designSystem.blockquote,
              }}
            >
              <MDXRenderer>{post.body}</MDXRenderer>
            </MDXProvider>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!, $locale: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug }, locale: { eq: $locale } }) {
      id
      tableOfContents(maxDepth: 3)
      body
      frontmatter {
        title
        date
        desc
      }
      fields {
        slug
        locale
      }
    }
  }
`;
